import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import DeleteModal from "components/modal/DeleteModal";
import ItineraryModal from "components/form/ItineraryModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import React, { useState, useContext } from "react";
import { SidebarContext } from "context/SidebarContext";
import Tooltip from "@mui/material/Tooltip";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import BillDetailsPayment from "components/modal/BillDetailsPaymentModal";
import { MdClose } from "react-icons/md";
import { notifySuccess, notifyError } from "utils/toast";
import BillDetailsPaymentServices from "services/BillDetailsPaymentServices";
import BillPaymentBulkModal from "components/modal/BillPaymentBulkModal";
import { IoIosClose } from "react-icons/io";
import { FaInfoCircle } from "react-icons/fa";
import BillApprovalServices from "services/BillApprovalServices";

const BillDetailsPaymentTable = ({
  billdetailspayment,
  perpage,
  currentPage,
  tab,
  hideEdit,
}) => {
  const { title, serviceId, handleView } = useToggleDrawer();
  const [showItineraryModal, setShowItineraryModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [requestAmount, setRequestAmount] = useState("");
  const [, setError] = useState("");
  const [selectedData, setSelectedData] = useState(null);
  const [roundedTds, setRoundedTds] = useState(null);
  const [roundedPayable, setRoundedPayable] = useState(null);
  const [, setSelectedBillDetailsPayment] = useState(null);
  const { setIsUpdate } = useContext(SidebarContext);
  const [, setIsRemarkModalOpen] = useState(false);
  const [itinerary] = useState("");
  const [open, setOpens] = useState(false);
  const [selectedRemark] = useState("");
  const [roundedOffDifference, setRoundedOffDifference] = useState(null);

  const [allData, setAllData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [outstandingData, setOutstandingData] = useState([]);
  const openZoomModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeZoomModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  const handleOpen = (data) => {
    setAllData(data);
    setOpens(true);
  };

  const closeModal = () => {
    setIsRemarkModalOpen(false);
    setShowModal(false);
    setSelectedBillDetailsPayment(null);
    setOpens(false);
  };

  const handleAmountChange = (e) => {
    setRequestAmount(e.target.value);
  };

  const handleSubmit = async (data) => {
    // console.log('handleSubmit', data);
    try {
      const response =
        await BillDetailsPaymentServices.updatebilldetailspayment(
          selectedData,
          data,
        );
      if (response?.status) {
        notifySuccess(response.message);
        setIsUpdate(true);
        closeModal();
      } else {
        // setError("Failed to submit the trip advance request.");
        notifyError(response?.message || "Failed to submit the payment.");
      }
    } catch (error) {
      //   console.error('API Error:', error);
      // setError("An error occurred while submitting the trip advance request.");
      notifyError(
        error?.response?.data?.message ||
          error?.message ||
          "An error occurred while submitting the payment.",
      );
    }
  };

  const handleSubmitReady = async (data) => {
    try {
      const response =
        await BillDetailsPaymentServices.updateBillReadypayment(data);
      if (response?.status) {
        notifySuccess(response.message);
        setIsUpdate(true);
        closeModal();
      } else {
        setError("Failed to submit the Bill Payment.");
      }
    } catch (error) {
      //   console.error('API Error:', error);
      setError("An error occurred while submitting the Bill Payment.");
    }
  };

  const groupedDatas = billdetailspayment.reduce((acc, row) => {
    const key = row.vendor_id;
    if (!acc[key]) {
      acc[key] = { ...row, trip_advance_paid: 0 };
    }
    acc[key].trip_advance_paid += row.trip_advance_paid;
    return acc;
  }, {});

  const groupedData = billdetailspayment.reduce((acc, row) => {
    let key;
    if (tab === 1) {
      key = row.vendor_name?.trim().toLowerCase();
      if (!acc[key]) {
        acc[key] = {
          ...row,
          ref_no: [row.ref_no],
          client_name: [row.client_name],
          no_of_days: [row.no_of_days],
          arrival: [row.arrival],
          departure: [row.departure],
          bill_amount: [row.bill_amount],
          start_date: [row.start_date],
          end_date: [row.end_date],
          va_start_date: [row.va_start_date],
          va_end_date: [row.va_end_date],
          days_difference: [row.days_difference],
          id: [row.id],
          trip_advance_paid: [row.trip_advance_paid],
          bill_adjusted_amount: [row.bill_adjusted_amount],
          net_payable_amount: [row.net_payable_amount],
          paid_status: [row.paid_status],
          has_pending_trip_advance: [row.has_pending_trip_advance],
          payment_history: [
            Array.isArray(row.payment_history) ? row.payment_history : [],
          ],
          total_paid_amount: [row.total_paid_amount],
        };
      } else {
        acc[key].ref_no.push(row.ref_no);
        acc[key].id.push(row.id);
        acc[key].trip_advance_paid.push(row.trip_advance_paid);
        acc[key].client_name.push(row.client_name);
        acc[key].no_of_days.push(row.no_of_days);
        acc[key].arrival.push(row.arrival);
        acc[key].departure.push(row.departure);
        acc[key].start_date.push(row.start_date);
        acc[key].end_date.push(row.end_date);
        acc[key].va_start_date.push(row.va_start_date);
        acc[key].va_end_date.push(row.va_end_date);
        acc[key].bill_amount.push(row.bill_amount);
        acc[key].days_difference.push(row.days_difference);
        acc[key].bill_adjusted_amount.push(row.bill_adjusted_amount);
        acc[key].net_payable_amount.push(row.net_payable_amount);
        acc[key].paid_status.push(row.paid_status);
        acc[key].has_pending_trip_advance.push(row.has_pending_trip_advance);
        acc[key].payment_history.push(
          Array.isArray(row.payment_history) ? row.payment_history : [],
        );
        acc[key].total_paid_amount.push(row.total_paid_amount);
      }
    } else {
      // key = row.ref_no?.trim().toLowerCase();
      key = `${row.ref_no?.trim().toLowerCase()}_${row.vendor_id}`;
      if (!acc[key]) {
        acc[key] = {
          ...row,
          trip_advance_paid: [row.trip_advance_paid],
          bill_amount: [row.bill_amount],
          days_difference: [row.days_difference],
          bill_adjusted_amount: [row.bill_adjusted_amount],
          id: [row.id],
          paid_status: [row.paid_status],
        };
      } else {
        acc[key].trip_advance_paid.push(row.trip_advance_paid);
        acc[key].bill_amount.push(row.bill_amount);
        acc[key].days_difference.push(row.days_difference);
        acc[key].bill_adjusted_amount.push(row.bill_adjusted_amount);
        acc[key].id.push(row.id);
        acc[key].paid_status.push(row.paid_status);
      }
    }
    return acc;
  }, {});

  const groupedArray = Object.values(groupedData);

  const calculateRoundingDifferences = (data) => {
    const billAmounts = Array.isArray(data.bill_amount)
      ? data.bill_amount
      : [data.bill_amount];
    // Before any adjustment has run, bill_adjusted_amount is 0 — fall back to
    // the raw bill_amount as the payable total for the rounding calc.
    const adjustedAmounts = (
      Array.isArray(data.bill_adjusted_amount)
        ? data.bill_adjusted_amount
        : [data.bill_adjusted_amount]
    ).map((amt, i) => (Number(amt) > 0 ? amt : billAmounts[i] || 0));
    const ids = Array.isArray(data.id) ? data.id : [data.id];

    const tds = billAmounts.map((amt, index) => {
      const amount = parseFloat(amt || 0);
      const original = +(amount * 0.01).toFixed(2);
      const rounded = Math.ceil(original);
      const difference = +(rounded - original).toFixed(2);
      return {
        id: ids[index] ?? null,
        original,
        rounded,
        difference,
      };
    });

    const adjusted = adjustedAmounts.map((amt, index) => {
      const amount = parseFloat(amt || 0);
      const original = +amount.toFixed(2);
      const rounded = Math.floor(original);
      const difference = +(rounded - original).toFixed(2);
      return {
        id: ids[index] ?? null,
        original,
        rounded,
        difference,
      };
    });

    return { tds, adjusted };
  };

  const renderImage = (imgUrl, index, onClickHandler) => (
    <img
      key={index}
      src={process.env.REACT_APP_API_IMAGE_URL + imgUrl}
      alt={`Bill Image ${index + 1}`}
      onClick={onClickHandler}
      className="w-12 h-12 object-cover rounded mr-2 cursor-pointer inline-block border border-gray-300 hover:scale-105 transition-transform"
    />
  );

  return (
    <>
      <DeleteModal id={serviceId} title={title} />
      <BillDetailsPayment
        title="Make Payment"
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        groupedData={groupedDatas}
        requestAmount={requestAmount}
        handleAmountChange={handleAmountChange}
        handleSubmit={handleSubmit}
        allData={allData}
        roundedOffDifference={roundedOffDifference}
        outstandingData={outstandingData}
      />
      <BillPaymentBulkModal
        title="Make Bulk Payment"
        isOpen={open}
        onClose={() => setOpens(false)}
        handleSubmitReady={handleSubmitReady}
        data={allData}
        roundedOffDifference={roundedOffDifference}
      />
      <ItineraryModal
        isOpen={showItineraryModal}
        content={itinerary}
        onClose={() => setShowItineraryModal(false)}
      />
      <TableBody>
        {tab !== 1 &&
          groupedArray.slice(0, perpage).map((data, index) => (
            <TableRow
              key={data.id || index}
              className={
                data.booking_status === 1 ? "bg-red-100 dark:bg-gray-500" : ""
              }
            >
              <TableCell className="text-center text-sm">
                {(currentPage - 1) * perpage + index + 1}
              </TableCell>
              <TableCell className="text-center text-sm">
                {data.ref_no}
              </TableCell>
              <TableCell className="text-center text-sm">
                {data.client_name}
              </TableCell>
              <TableCell>
                <div className="flex flex-col row-gap-4 text-sm items-center">
                  <p className="m-0">{data.start_date}</p>
                  <p className="m-0">{data.end_date}</p>
                </div>
              </TableCell>
              <TableCell>
                <div className="flex flex-col row-gap-4 text-sm items-center">
                  <p className="m-0">{data.arrival}</p>
                  <p className="m-0">{data.departure}</p>
                </div>
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.vendor_name}
              </TableCell>
              {/* <TableCell className="text-center text-sm">
                <div className="flex flex-col row-gap-4 text-sm items-center">
                  <p className="m-0">{data.va_start_date}</p>
                  <p className="m-0">{data.va_end_date}</p>
                </div>
              </TableCell> */}
              <TableCell className="text-center text-sm">
                {data.bill_amount.map((request, i) => (
                  <div key={`request-${i}`}>{request}</div>
                ))}
              </TableCell>
              <TableCell className="text-center text-sm">
                {data.days_difference.map((request, i) => (
                  <div key={`request-${i}`}>{request}</div>
                ))}
              </TableCell>
              {/* <TableCell className="text-center text-sm">
                {data.bill_amount.map((amount, i) => {
                  const tds_trip = Math.ceil(amount * 0.01);
                  return (
                    <p key={`tds-${i}`} className="m-0">
                      {tds_trip}
                    </p>
                  );
                })}
              </TableCell> */}

              <TableCell className="text-center text-sm">
                <p className="m-0">{data?.TDS}</p>
              </TableCell>
              <TableCell className="text-center text-sm" key="total">
                {data.trip_advance_paid.map((request, i) => (
                  <div key={`ta-${i}`}>{parseFloat(request || 0)}</div>
                ))}
              </TableCell>
              {tab !== 2 && (
                <TableCell className="text-center text-sm">
                  {data.bill_adjusted_amount.map((request, i) => {
                    // net_payable_amount is fully netted server-side:
                    // (bill_adjusted_amount or bill_amount) - TDS - trip_advance_paid.
                    const payable =
                      data.net_payable_amount !== undefined &&
                      data.net_payable_amount !== null
                        ? Number(data.net_payable_amount)
                        : Number(request) > 0
                          ? request
                          : data.bill_amount?.[i] || 0;
                    const roundedDown = Math.floor(parseFloat(payable || 0));
                    return <div key={`request-${i}`}>{roundedDown}</div>;
                  })}
                </TableCell>
              )}
              {/* <TableCell className="text-center text-sm">
                {data.bill_adjusted_amount.map((request, i) => {
                  // net_payable_amount is fully netted server-side:
                  // (bill_adjusted_amount or bill_amount) - TDS - trip_advance_paid.
                  const payable =
                    data.net_payable_amount !== undefined &&
                    data.net_payable_amount !== null
                      ? Number(data.net_payable_amount)
                      : Number(request) > 0
                        ? request
                        : data.bill_amount?.[i] || 0;
                  const roundedDown = Math.floor(parseFloat(payable || 0));
                  return <div key={`request-${i}`}>{roundedDown}</div>;
                })}
              </TableCell> */}
              <TableCell className="text-center">
                {tab == 1
                  ? "-" // show dash only in tab 1
                  : Array.isArray(data?.bill_images)
                    ? data.bill_images.map((image, i) =>
                        renderImage(image, i, () => openZoomModal(image)),
                      )
                    : typeof data?.bill_images === "string"
                      ? data.bill_images
                          .split(",")
                          .map((image, i) =>
                            renderImage(image.trim(), i, () =>
                              openZoomModal(image.trim()),
                            ),
                          )
                      : null}
              </TableCell>

              {(() => {
                const payments = Array.isArray(data.payment_history)
                  ? data.payment_history
                  : [];
                const totalPaid = Number(data.total_paid_amount) || 0;

                const rowInfos = data.paid_status.map((paid, i) => {
                  // net_payable_amount is already fully netted server-side:
                  // (bill_adjusted_amount or bill_amount) - TDS - trip_advance_paid.
                  const payable =
                    data.net_payable_amount !== undefined &&
                    data.net_payable_amount !== null
                      ? Number(data.net_payable_amount)
                      : Number(data.bill_adjusted_amount?.[i]) > 0
                        ? Number(data.bill_adjusted_amount[i])
                        : Number(data.bill_amount?.[i]) || 0;
                  const remaining = payable - totalPaid; // can be negative if the vendor owes money back
                  return { i, paid, payable, remaining };
                });

                const openPayModal = async (prefillAmount) => {
                  const i = rowInfos[0].i;
                  handleView(data.id[i]);
                  setSelectedData(data.id[i]);
                  setAllData(data);
                  setRequestAmount(prefillAmount);

                  const roundedData = calculateRoundingDifferences(data);
                  setRoundedOffDifference(roundedData);

                  try {
                    const response =
                      await BillApprovalServices.checkoutstanding(
                        data.vendor_id,
                      );
                    setOutstandingData(response?.status ? response.data : []);
                  } catch (err) {
                    console.error("API Error:", err);
                    setOutstandingData([]);
                  }

                  setShowModal(true);
                };

                return (
                  <>
                    {/* Status */}
                    <TableCell className="text-center">
                      {rowInfos.map(({ i, paid, payable }) => {
                        // Computed server-side (is_overpaid) — trip advance
                        // paid + any debt adjustment exceeded the bill, nothing
                        // left to collect from this vendor.
                        const isOverpaid = data.is_overpaid === true;
                        const overpaidTitle = `Overpaid by ₹${Math.abs(
                          Math.floor(payable),
                        )} — trip advance paid exceeded the bill amount`;
                        return paid && paid === "1" ? (
                          <div key={`status-${i}`} className="mb-2">
                            <span className="text-green-600 font-semibold">
                              PAID
                            </span>
                            {isOverpaid && (
                              <Tooltip title={overpaidTitle} arrow>
                                <div className="text-xs text-green-700 font-semibold cursor-pointer">
                                  (Overpaid)
                                </div>
                              </Tooltip>
                            )}
                          </div>
                        ) : isOverpaid ? (
                          <div key={`status-${i}`} className="mb-2">
                            <Tooltip title={overpaidTitle} arrow>
                              <span className="text-green-600 font-semibold cursor-pointer">
                                Overpaid
                              </span>
                            </Tooltip>
                          </div>
                        ) : totalPaid > 0 ? (
                          <div key={`status-${i}`} className="mb-2">
                            <span className="text-orange-500 font-semibold">
                              Partially Paid
                            </span>
                          </div>
                        ) : (
                          <div key={`status-${i}`} className="mb-2">
                            <span className="text-red-500 font-semibold">
                              Yet to Pay
                            </span>
                          </div>
                        );
                      })}
                    </TableCell>

                    {/* Payment History — same cascading pending_before/running_balance
                        pattern as Trip Advance Payment: row 0's pending_before already
                        IS the original payable ceiling, paired directly with that first
                        payment's own icon + combined Paid — no separate static line.
                        Followed by a trailing row for the current true balance. */}
                    <TableCell className="text-center text-sm">
                      {payments.length === 0 ? (
                        <span className="text-gray-400">—</span>
                      ) : (
                        <>
                          {payments.map((p, idx) => {
                            const pending = Number(p.pending_before) || 0;
                            const combinedPaid =
                              Number(p.amount || 0) +
                              Number(p.adjusted_amount || 0);
                            return (
                              <div
                                key={idx}
                                className="flex justify-center items-center gap-4 w-full mt-1"
                              >
                                <div
                                  className={
                                    pending <= 0
                                      ? "text-green-600"
                                      : "text-red-600"
                                  }
                                  style={{ minWidth: 60, textAlign: "center" }}
                                >
                                  {pending}
                                </div>
                                <div
                                  className="flex justify-center items-center"
                                  style={{ minWidth: 30 }}
                                >
                                  <Tooltip
                                    title={
                                      <div className="text-sm space-y-2">
                                        {Number(p.adjusted_amount) > 0 && (
                                          <div className="pb-2 border-b border-gray-400">
                                            <div>
                                              <strong className="text-yellow-300">
                                                Adjustment Applied: ₹
                                                {p.adjusted_amount}
                                              </strong>
                                            </div>
                                            <div className="text-xs text-gray-300 mt-1">
                                              From Outstanding Credits:
                                            </div>
                                            {(p.adjustments || []).map(
                                              (adj, aIdx) => (
                                                <div
                                                  key={aIdx}
                                                  className="text-xs text-gray-200 ml-2 mt-1"
                                                >
                                                  ₹{adj.adjusted_amount} from{" "}
                                                  {adj.ref_no || adj.va_id}
                                                  {adj.client_name
                                                    ? ` (${adj.client_name})`
                                                    : ""}
                                                </div>
                                              ),
                                            )}
                                          </div>
                                        )}
                                        {Number(p.amount) > 0 && (
                                          <div>
                                            <div>
                                              <strong
                                                className={
                                                  Number(p.adjusted_amount) > 0
                                                    ? "text-green-300"
                                                    : ""
                                                }
                                              >
                                                {Number(p.adjusted_amount) > 0
                                                  ? "Cash Payment:"
                                                  : "Payment Details:"}
                                              </strong>
                                            </div>
                                            <div className="mt-1">
                                              Amount:{" "}
                                              <strong>₹{p.amount}</strong>
                                            </div>
                                            <div>
                                              Date:{" "}
                                              {new Date(
                                                p.paid_date,
                                              ).toLocaleString()}
                                            </div>
                                            <div>
                                              Type: {p.payment_type || "N/A"}
                                            </div>
                                            {p.utr && <div>UTR: {p.utr}</div>}
                                          </div>
                                        )}
                                      </div>
                                    }
                                    arrow
                                  >
                                    <span>
                                      <FaInfoCircle className="text-blue-500 cursor-pointer mx-2" />
                                    </span>
                                  </Tooltip>
                                </div>
                                <div
                                  className="font-semibold"
                                  style={{ minWidth: 70, textAlign: "center" }}
                                >
                                  Paid: {combinedPaid}
                                </div>
                              </div>
                            );
                          })}
                          <div className="flex justify-center items-center gap-4 w-full mt-1">
                            <div
                              className={
                                Number(data.net_payable_amount) <= 0
                                  ? "text-green-600"
                                  : "text-red-600"
                              }
                              style={{ minWidth: 60, textAlign: "center" }}
                            >
                              {Number(data.net_payable_amount) || 0}
                            </div>
                            <div style={{ minWidth: 30 }} />
                            <div style={{ minWidth: 70 }} />
                          </div>
                        </>
                      )}
                    </TableCell>

                    {/* Action — hidden entirely on the Paid tab, nothing to do there */}
                    {tab !== 2 && (
                      <TableCell className="text-center">
                        {rowInfos.map(({ i, paid, payable, remaining }) => (
                          <div key={`action-${i}`} className="mb-2">
                            {paid === "1" ? (
                              <span className="text-gray-400">-</span>
                            ) : !hideEdit ? (
                              <span className="text-gray-400">-</span>
                            ) : data.is_payable === false ? (
                              // Computed server-side — nothing left to collect
                              // (overpaid, or otherwise already fully settled).
                              <span className="text-gray-400">-</span>
                            ) : (
                              <button
                                className="ml-2 px-2 py-1 text-sm text-white bg-yellow-500 rounded hover:bg-yellow-600"
                                onClick={() =>
                                  // payable (net_payable_amount) is already net
                                  // of everything paid so far — server-side —
                                  // so it's already the true remaining amount.
                                  // Subtracting totalPaid again here would
                                  // double-count it.
                                  openPayModal(payable)
                                }
                              >
                                {totalPaid > 0 ? "Pay Remaining" : "Pay"}
                              </button>
                            )}
                          </div>
                        ))}
                      </TableCell>
                    )}
                  </>
                );
              })()}
            </TableRow>
          ))}
        {tab === 1 &&
          groupedArray.slice(0, perpage).map((data, index) => (
            <TableRow key={data.id || index}>
              <TableCell className="text-center text-sm">
                {(currentPage - 1) * perpage + index + 1}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.vendor_name}
              </TableCell>
              <TableCell className="text-center text-sm">
                {data.bill_adjusted_amount.map((request, i) => (
                  <div className="mb-4 pb-2" key={`name-${i}`}>
                    {data.ref_no[i]}
                  </div>
                ))}
              </TableCell>
              <TableCell className="text-center text-sm">
                {data.bill_adjusted_amount.map((request, i) => (
                  <div className="mb-4 pb-2" key={`name-${i}`}>
                    {data.client_name[i]}
                  </div>
                ))}
              </TableCell>
              <TableCell>
                {data.bill_adjusted_amount.map((request, i) => (
                  <div
                    className="mb-4 pb-2 flex flex-col row-gap-4 text-sm items-center"
                    key={`date-${i}`}
                  >
                    <p className="m-0">{data.start_date[i]}</p>
                    <p className="m-0">{data.end_date[i]}</p>
                  </div>
                ))}
              </TableCell>
              <TableCell>
                {data.bill_adjusted_amount.map((request, i) => (
                  <div
                    className="mb-4 pb-2 flex flex-col row-gap-4 text-sm items-center"
                    key={`date-${i}`}
                  >
                    <p className="m-0">{data.arrival[i]}</p>
                    <p className="m-0">{data.departure[i]}</p>
                  </div>
                ))}
              </TableCell>
              {/* <TableCell className="text-center text-sm">
                {data.bill_adjusted_amount.map((request, i) => (
                  <div
                    className="mb-4 pb-2 flex flex-col row-gap-4 text-sm items-center"
                    key={`date-${i}`}
                  >
                    <p className="m-0">{data.va_start_date[i]}</p>
                    <p className="m-0">{data.va_end_date[i]}</p>
                  </div>
                ))}
              </TableCell> */}
              <TableCell className="text-center text-sm">
                {data.bill_amount.map((request, i) => (
                  <div className="mb-4 pb-2" key={`request-${i}`}>
                    {request}
                  </div>
                ))}
              </TableCell>
              <TableCell className="text-center text-sm">
                {data.days_difference.map((request, i) => (
                  <div className="mb-4 pb-2" key={`request-${i}`}>
                    {request}
                  </div>
                ))}
              </TableCell>
              <TableCell className="text-center text-sm">
                {data.bill_amount.map((amount, i) => {
                  const tds_trip = Math.ceil(amount * 0.01);
                  return (
                    <p key={`tds-${i}`} className="mb-4 pb-2">
                      {tds_trip}
                    </p>
                  );
                })}
              </TableCell>
              <TableCell className="text-center text-sm" key="total">
                {data.trip_advance_paid.map((request, i) => (
                  <div className="mb-4 pb-2" key={`ta-${i}`}>
                    {parseFloat(request || 0)}
                  </div>
                ))}
              </TableCell>
              <TableCell className="text-center text-sm">
                {data.bill_adjusted_amount.map((request, i) => {
                  // net_payable_amount is fully netted server-side:
                  // (bill_adjusted_amount or bill_amount) - TDS - trip_advance_paid.
                  const payable =
                    data.net_payable_amount?.[i] !== undefined &&
                    data.net_payable_amount?.[i] !== null
                      ? Number(data.net_payable_amount[i])
                      : Number(request) > 0
                        ? request
                        : data.bill_amount?.[i] || 0;
                  const roundedDown = Math.floor(parseFloat(payable || 0));
                  return (
                    <div className="mb-4 pb-2" key={`request-${i}`}>
                      {roundedDown}
                    </div>
                  );
                })}
              </TableCell>
              <TableCell>-</TableCell>

              {/* Status */}
              <TableCell className="text-center text-sm">
                {data.paid_status.map((paid, i) => (
                  <div className="mb-4 pb-2" key={`status-${i}`}>
                    {paid === "1" ? (
                      <span className="text-green-600 font-semibold">PAID</span>
                    ) : Number(data.total_paid_amount?.[i]) > 0 ? (
                      <span className="text-orange-500 font-semibold">
                        Partially Paid
                      </span>
                    ) : (
                      <span className="text-red-500 font-semibold">
                        Yet to Pay
                      </span>
                    )}
                  </div>
                ))}
              </TableCell>

              {/* Payment History */}
              <TableCell className="text-center text-sm">
                {data.paid_status.map((_, i) => {
                  const payments = Array.isArray(data.payment_history?.[i])
                    ? data.payment_history[i]
                    : [];
                  const totalPaid = Number(data.total_paid_amount?.[i]) || 0;
                  const payable =
                    data.net_payable_amount?.[i] !== undefined &&
                    data.net_payable_amount?.[i] !== null
                      ? Number(data.net_payable_amount[i])
                      : Number(data.bill_adjusted_amount?.[i]) > 0
                        ? Number(data.bill_adjusted_amount[i])
                        : Number(data.bill_amount?.[i]) || 0;
                  // payable (net_payable_amount) is already net of everything
                  // paid so far — server-side — so it IS the true remaining
                  // amount already. Subtracting totalPaid again here would
                  // double-count it.
                  return (
                    <div className="mb-4 pb-2" key={`history-${i}`}>
                      {payments.length > 0 ? (
                        <Tooltip
                          title={
                            <div>
                              {payments.map((p, idx) => (
                                <div key={idx} className="mb-2">
                                  <strong>Payment {idx + 1}:</strong> {p.amount}{" "}
                                  on{new Date(p.paid_date).toLocaleString()}(
                                  {p.payment_type || "N/A"}
                                  {p.utr ? `, UTR: ${p.utr}` : ""})
                                  {Array.isArray(p.adjustments) &&
                                    p.adjustments.length > 0 && (
                                      <div className="mt-1">
                                        {p.adjustments.map((adj, aIdx) => (
                                          <div
                                            key={aIdx}
                                            className="text-orange-500"
                                          >
                                            + {adj.adjusted_amount} adjusted
                                            from booking{" "}
                                            {adj.ref_no || adj.va_id}
                                            {adj.client_name
                                              ? ` (${adj.client_name})`
                                              : ""}
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                </div>
                              ))}
                            </div>
                          }
                          placement="top-start"
                          arrow
                        >
                          <span className="text-blue-600 cursor-pointer underline">
                            {payments.length} payment
                            {payments.length > 1 ? "s" : ""}
                          </span>
                        </Tooltip>
                      ) : (
                        <span className="text-gray-400">—</span>
                      )}
                      {totalPaid > 0 && payable > 0 && (
                        <div className="text-xs text-gray-500">
                          Remaining: {payable}
                        </div>
                      )}
                    </div>
                  );
                })}
              </TableCell>

              <TableCell className="text-center">
                {hideEdit ? (
                  <button
                    className="ml-2 px-2 py-1 text-sm text-white bg-yellow-500 rounded hover:bg-yellow-600"
                    onClick={() => {
                      // console.log(data); // confirm full object is here
                      const roundingInfo = calculateRoundingDifferences(data);
                      setRoundedOffDifference(roundingInfo); // store tds/adjusted with ids
                      setSelectedData(data.id); // optional if you need just the ids
                      setAllData(data); // store full data
                      handleOpen(data.id); // still ok to pass ids
                    }}
                  >
                    Pay
                  </button>
                ) : (
                  <span className="text-red-500 font-semibold">Yet to Pay</span>
                )}
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
      {isModalOpen && (
        <div
          role="dialog"
          aria-modal="true"
          className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeZoomModal();
            }
          }}
        >
          <div className="bg-white dark:bg-gray-600 p-4 rounded-lg max-w-md w-full relative">
            <button
              onClick={closeZoomModal}
              className="viewModelBoxCloseBtn bg-white dark:bg-gray-600 dark:text-white absolute top-2 right-2 text-2xl"
            >
              <IoIosClose />
            </button>

            {selectedImage && (
              <img
                src={process.env.REACT_APP_API_IMAGE_URL + selectedImage}
                alt="Selected Image"
                className="w-full max-h-[90vh] h-auto rounded-lg object-contain"
                loading="lazy"
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default BillDetailsPaymentTable;
